module.exports = __webpack_public_path__ + "static/media/Qase_online_collaboration_tools_0.e3d3f4ee.png";